import { render, staticRenderFns } from "./lateDeliveryAndShipping.vue?vue&type=template&id=90b186f2&scoped=true"
import script from "./lateDeliveryAndShipping.vue?vue&type=script&lang=js"
export * from "./lateDeliveryAndShipping.vue?vue&type=script&lang=js"
import style0 from "./lateDeliveryAndShipping.vue?vue&type=style&index=0&id=90b186f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b186f2",
  null
  
)

export default component.exports